// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"3ddb91d3","917":"105392ea"}[chunkId] + ".chunk.js";
};